import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Helmet, HelmetProvider } from 'react-helmet-async';
import './Videos.css';
import { fetchInitialData } from "../fetchData";
import Right from '../right/Right';
import ShareOptions from './common/ShareOptions';
import Service from '../service/Service';
import YouTube from 'react-youtube';
import withLocation from "../../withLocation";

const service = new Service();

class Videos extends Component {
    constructor(props) {
        super(props);
        let initialData = {};
        let videoData = [];
        let keywordData = [];
        let dob = []
        let childid = []
        let childname = []
        let childgender = []
        let childlist = []
        let childpic = []
        let isexpectedchild = []
        let childage = []
        let serverSideData = {};

        this.SelectChild = this.SelectChild.bind(this);

        if (__isBrowser__ && window.__initialData__ && window.__initialData__['initialData']) {
            serverSideData = window.__initialData__['initialData'];
        let childList = global.userAry['childData']?.UserChildList || [];

        const userChildList = global.userAry['childData']?.UserChildList || [];
        console.log("userChildList updated line =")

            if (userChildList && userChildList !== null) {
                const currentDate = new Date();

                // Filter out children with DOB greater than the current date
                // console.log("--------here DOB:::::1", userChildList)
                const filteredChildList = userChildList.filter(child => {
                    const dob = new Date(child.DOB);
                    return dob <= currentDate;
                });

                if (userChildList.length > 0) {
                    const ageCategoryToImage1 = {
                        "0": 'https://cdn.cdnparenting.com/brainbees/community/preact/public/media/01-Infant.webp',
                        "7": 'https://cdn.cdnparenting.com/brainbees/community/preact/public/media/02-Baby.webp',
                        "1": 'https://cdn.cdnparenting.com/brainbees/community/preact/public/media/03-Toddler.webp',
                        "2": 'https://cdn.cdnparenting.com/brainbees/community/preact/public/media/04-Kids.webp',
                        "8": 'https://cdn.cdnparenting.com/brainbees/community/preact/public/media/05-Big Kids.webp',
                        "5": 'https://cdn.cdnparenting.com/brainbees/community/preact/public/media/06-Expecting.webp',
                        "4": 'https://cdn.cdnparenting.com/brainbees/community/preact/public/media/07-Trying-to-concieve.webp'
                    };
                    let ageCategory;
                    let photoUrl;
                    if (userChildList[0].Age && !userChildList[0].IsExpected) {
                        ageCategory = this.getAgeCategory(userChildList[0].Age);
                        photoUrl = ageCategoryToImage1[ageCategory] || (userChildList[0].Gender == 'Boy' ? 'https://parenting.firstcry.com/my-account/images/ic_boy_community.png' : 'https://parenting.firstcry.com/my-account/images/ic_girl_community.jpg');
                    }
                    else {
                        photoUrl = "https://cdn.cdnparenting.com/brainbees/community/preact/public/media/06-Expecting.jpg"
                    }

                    // console.log("ageCategory :::::::::::::::::::::::", ageCategory)
                    // console.log("photoUrl ::::::::::::::::::::::::::", photoUrl)

                    dob = userChildList[0].DOB || "";
                    childid = userChildList[0].ChildId || "";
                    childname = userChildList[0].ChildName || "";
                    childgender = userChildList[0].Gender || "";
                    childpic = userChildList[0].childPhoto || photoUrl;
                    isexpectedchild = userChildList[0].IsExpected || "";
                    childage = userChildList[0].Age || "";
                    childlist = userChildList;

                    console.log('ChildList:-------------', childlist);
                } else {
                    // Handle the case where no valid children are found
                    dob = "";
                    childid = "";
                    childname = "";
                    childgender = "";
                    childpic = "";
                    isexpectedchild = "";
                    childage = "";
                    childlist = [];
                }
            }

            console.log("userChildList:>: ", userChildList);

            delete window.__initialData__;


        } else {
            if (props.staticContext && props.staticContext.initialData && props.staticContext.initialData['initialData']) {
                serverSideData = props.staticContext.initialData['initialData'];
            }
        }
        console.log("serverSideData:::", serverSideData)
        if (serverSideData) {
            initialData = serverSideData;
            if (serverSideData['videos']) {
                videoData = serverSideData['videos'];
            }
            if (serverSideData['keywordList']) {
                keywordData = serverSideData['keywordList'];
            }
        }

        let selectedChild = {
            name: childname ? childname : "",
            age: childage ? childage : "",
            photo: childpic ? childpic : '',
            expected: isexpectedchild ? isexpectedchild : "",
        };

        this.state = {
            initialData: initialData,
            videoData: videoData,
            keywordData: keywordData,
            activeKey: "All",
            videoHeight: 360,
            videoWidth: 500,
            windowWidth: 1024,
            isLoadead : true,
            childlist: childlist,
            selectedChild: selectedChild,
            showDropdownBody: true,
            metaTitle: "Videos: Pregnancy, Baby Care & Parenting | FirstCry Parenting",
            metaDescription: [
                { "name": "description", "content": "Watch our exclusive collection of videos to get the information about pregnancy, delivery, newborn care, baby development, breastfeeding, parenting and more." },
                { "name": "keywords", "content": "pregnancy video,  baby care video, breastfeeding videos, parenting videos" },
                { "name": "atdlayout", "content": "tools_sp" }
            ]
        };
        this.videoPageNo = 1;
        this.maxScroll = 0;
        this.timeout = 0;
        this.playList = [];
    }

    static initialAction(reqUrl, ftk, authData, uId, childData) {
        var header = {
            'Content-Type': 'application/json',
            'ftk': ftk,
            'uid': uId,
            'access-token': authData['access-token'],
            'user-agent': global.userAgent,
            'isdesktop': global.isdesktop
        }
        var url = global.api_url + "getVideos";
        let body = JSON.stringify({
            "searchkey": "All",
            "pageSize": 10,
            "pageNo": 1,
            "childDob": childData && childData['UserChildList'] && childData['UserChildList'].length > 0 ? childData['UserChildList'][0]['DOB'] : "",
            "isExpecting": childData && childData['UserChildList'] && childData['UserChildList'].length > 0 ? childData['UserChildList'][0]['IsExpected'] : 0
        })
        return fetchInitialData(url, JSON.stringify(header), body);
    }

    componentDidMount() {
        this.setVideoDimention();
        this.setState({ windowWidth: window.innerWidth });
        document.addEventListener("click", this.domClick);
        this.pageData = this.pageData.bind(this);
        window.addEventListener("scroll", this.pageData, false);
        if (navigator.onLine) {
            if (!this.state.initialData || (this.state.initialData && Object.keys(this.state.initialData).length < 1)) {
                service.showLoader();
                this.videoData(1);
            } else {
                localStorage.setItem('videoData', JSON.stringify(this.state.initialData));
                this.setKeySliderWidth();
            }
        } else {
            if (localStorage.getItem('videoData')) {
                this.setState({
                    initialData: JSON.parse(localStorage.getItem('videoData')),
                    videoData: JSON.parse(localStorage.getItem('videoData'))['videos'],
                    keywordData: JSON.parse(localStorage.getItem('videoData'))['keywordList']
                }, () => { this.setKeySliderWidth(); });
            }
            service.hideLoader();
        }
        var _this = this;
        setTimeout(function () {
            _this.setKeySliderWidth();
        }, 3000)
    }

    componentWillUnmount() {
        document.removeEventListener("click", this.domClick);
        window.removeEventListener("scroll", this.pageData, false);
    }

    domClick() {
        if (!event.target.classList.contains('share-click')) {
            let ary = document.getElementsByClassName('sharing-options');
            for (let i = 0; i < ary.length; i++) {
                ary[i].style.display = 'none';
            }
            if (document.getElementsByClassName('share-overlay')[0]) {
                document.getElementsByClassName('share-overlay')[0].style.display = 'none';
            }
        }
    }

    videoData(pageno) {
        var postData = {
            "searchkey": this.state.activeKey,
            "pageSize": 10,
            "pageNo": pageno
        }
        var url = global.api_ci_url + "Videos/getVideosData";
        service.postServiceCall(url, postData).then((json) => {
            if (json['msg'] == "1") {
                this.setState({isLoadead:true});
                if (this.state.videoData.length > 0 || this.state.activeKey != 'All') {
                    if (pageno == 1) {
                        this.setState({ videoData: json['videos'] });
                    } else {
                        let ary = this.state.videoData;
                        this.setState({ videoData: ary.concat(json['videos']) });
                    }
                } else {
                    localStorage.setItem('videoData', JSON.stringify(json));
                    this.setState({
                        initialData: json,
                        videoData: json['videos'],
                        keywordData: json['keywordList']
                    }, () => { this.setKeySliderWidth(); });
                }
            }
            service.hideLoader();
            service.hideTracking();
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
            service.hideTracking();
        });
    }

    changeKey(key) {
        this.setState({ activeKey: key }, () => { service.scrollCenterKeySlider(); service.showLoader(); this.videoPageNo = 1; this.videoData(1); });
    }

    pageData() {
        if (window.matchMedia('(max-width: 767px)').matches) {
            let checkScrollVal = 80;
            if (this.props.location.search.includes('from=app')) {
                checkScrollVal = 0;
            }
            if (window.pageYOffset > checkScrollVal) {
                document.querySelector('.video_tabs').classList.add('sticky_tracker_heading');
                if (this.props.location.search.includes('from=app')) {
                    document.querySelector('.video_tabs.sticky_tracker_heading').style.top = '0';
                }
            } else {
                document.querySelector('.video_tabs').classList.remove('sticky_tracker_heading');
            }
        }
        var _this = this;
        clearTimeout(_this.timeout);
        _this.timeout = setTimeout(function () {
            if (document.getElementsByClassName('data-container')[0]) {
                var cS = document.getElementsByClassName('data-container')[0].offsetTop;
                var cH = document.getElementsByClassName('data-container')[0].offsetHeight - 2000,
                    wS = window.scrollY - cS;
                if (!((window.innerHeight + window.scrollY) >= document.body.offsetHeight) && wS > cH) {
                    if (wS > _this.maxScroll) {
                        _this.maxScroll = wS;
                        ++_this.videoPageNo;
                        service.showLoader();
                        service.showTracking();
                        document.getElementById('pageNo').value = _this.videoPageNo;
                        if(_this.videoPageNo > 5){
                                var heightCal = document.querySelector('.footer_fclogo_text_container') ? document.querySelector('.footer_fclogo_text_container').clientHeight : 400; 
                                window.scrollTo(window.scrollX, (window.scrollY-heightCal));
                                _this.videoData(_this.videoPageNo);
                        }else{
                            _this.videoData(_this.videoPageNo);
                        }
                        _this.setState({isLoadead:false});
                    } else {
                        return false;
                    }
                }
            }
        }, 100)
    }

    setKeySliderWidth() {
        var totallistlength = 0;
        var liAry = document.querySelector(".video_tabs ul").getElementsByTagName('li');
        for (var i = 0; i < liAry.length; i++) {
            totallistlength = totallistlength + liAry[i].offsetWidth + 15;
        }
        if (!window.matchMedia('(max-width: 767px)').matches) {
            totallistlength = totallistlength + 60;
        }
        document.querySelector(".video_tabs ul").style.width = totallistlength + 'px';
    }

    setVideoDimention() {
        var videoHeight;
        if (window && window.innerWidth < 767) {
            var userAgent = navigator.userAgent || navigator.vendor || window.opera;
            if (/android/i.test(userAgent)) {
                videoHeight = window.innerWidth / 1.792;
            }
            if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
                videoHeight = (window.innerWidth - 20) * 0.56;
            }
            this.setState({
                videoHeight: videoHeight
            })
        }
        if (window && window.innerWidth) {
            this.setState({
                videoWidth: window.innerWidth
            })
        }
    }

    onPlayerStateChange = (event) => {
        // console.log(event);
        // console.log(event.target.playerInfo.videoData);
        // console.log(event.target.f.offsetParent);
        let id = event.target.f.offsetParent.getAttribute('data-id');
        if (event.data == 3) {
            this.playList.push(id);
        } else if (event.data == 1 && this.playList.includes(id)) {
            this.saveVideoAction(id, "view", "1")
        }
    }

    saveVideoAction(id, type, status) {
        if (type == "like") {
            service.showLoader();
        }
        let gender = 'NA';
        let genderNo = '';
        if (global.userAry['Sex'] && global.userAry['Sex'] != '') {
            gender = global.userAry['Sex'];
            genderNo = gender.toLowerCase() == 'male' ? 0 : 1;
        }
        let childAry = [];
        global.userAry['childData'] && global.userAry['childData']['UserChildList'] && global.userAry['childData']['UserChildList'].forEach((child) => {
            let obj = {};
            obj["gender"] = child['Gender'].toLowerCase();
            obj["dob"] = child['DOB'];
            obj["childId"] = child['ChildId'];
            obj["childName"] = child['ChildName'];
            obj["childPic"] = child['childPhoto'];
            childAry.push(obj);
        })
        var postData = {
            "videoId": id,
            "action_type": type,
            "action_status": status.toString(),
            "userPic": global.userAry['userPhoto'],
            "userName": global.userAry['userName'],
            "userGender": genderNo,
            "childArr": childAry,
        }
        var url = global.api_ci_url + "Videos/saveVideoAction";
        service.postServiceCall(url, postData).then((json) => {
            console.log(json);
            if (parseInt(json['msg']) == 1) {
                this.changeData(id, type, status);
            } else {
                // service.showAlert("Fail");
            }
            service.hideLoader();
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
        });
    }

    changeData(id, type, status) {
        let videoData = this.state.videoData;
        videoData && videoData.forEach((video) => {
            if (video.id == id) {
                if (type == "view") {
                    if (parseInt(status) == 1) {
                        video.view_count = parseInt(video.view_count) + 1;
                    }
                } else if (type == "like") {
                    if (parseInt(status) == 1) {
                        video.isLike = true;
                        video.like_count = parseInt(video.like_count) + 1;
                    } else if (parseInt(status) == 0) {
                        video.isLike = false;
                        video.like_count = parseInt(video.like_count) - 1;
                    }
                } else if (type == "bookmark") {
                    if (parseInt(status) == 1) {
                        video.isBookmarked = true;
                        video.bookmarkCount = parseInt(video.bookmarkCount) + 1;
                    } else if (parseInt(status) == 0) {
                        video.isBookmarked = false;
                        video.bookmarkCount = parseInt(video.bookmarkCount) - 1;
                    }
                }
            }
        });
        this.setState({ videoData: videoData });
    }

    shareOn(id) {
        let ary = document.getElementsByClassName('sharing-options');
        for (let i = 0; i < ary.length; i++) {
            ary[i].style.display = 'none';
        }
        document.getElementById('share_' + id).getElementsByClassName('sharing-options')[0].style.display = 'block';
        if (window.innerWidth < 767) {
            if (document.getElementsByClassName('share-overlay')[0]) {
                document.getElementsByClassName('share-overlay')[0].style.display = 'block';
            }
        }
    }

    shareVideo(shareoption, articleurl) {
        var shareurl;
        let ary = document.getElementsByClassName('sharing-options');
        for (let i = 0; i < ary.length; i++) {
            ary[i].style.display = 'none';
        }
        if (document.getElementsByClassName('share-overlay')[0]) {
            document.getElementsByClassName('share-overlay')[0].style.display = 'none';
        }
        if (shareoption == "facebook") {
            shareurl = 'https://www.facebook.com/sharer/sharer.php?u=';
        } else if (shareoption == "twitter") {
            shareurl = 'https://twitter.com/share?url=';
        } else if (shareoption == "pintrest") {
            shareurl = 'https://www.pinterest.com/pin/create/button/?url=';
        } else if (shareoption == "whatsapp") {
            shareurl = 'whatsapp://send?text=';
        }
        var sharewindow = window.open(shareurl + articleurl, shareoption + '-popup', 'height=350,width=600');
        if (sharewindow.focus) {
            sharewindow.focus();
        }
        return false;
    }

    redirectToYoutube() {
        service.showAlert('You are now being redirected to FirstCry Youtube Channel.');
        window.open("https://www.youtube.com/user/firstcrydotcom?sub_confirmation=1", "_blank");

        // if (window.innerWidth < 767) {
        //     window.open("https://www.youtube.com/user/firstcrydotcom?sub_confirmation=1", "_blank");
        // } else {
        //     window.open("https://www.youtube.com/user/firstcrydotcom", "_blank");
        // }

        // var anchor = document.createElement("a");
        // anchor.target = "_blank";
        // if (window.innerWidth < 767) {
        //     anchor.href = "https://www.youtube.com/user/firstcrydotcom?sub_confirmation=1";
        // } else {
        //     anchor.href = "https://www.youtube.com/user/firstcrydotcom";
        // }
        // anchor.click();
    }

    saveVideoSubscription() {
        if (global.ftk != '') {
            var postData = {}
            var url = global.api_ci_url + "Videos/saveVideoSubscription";
            service.postServiceCall(url, postData).then((json) => {
                if (parseInt(json['msg']) == 1) {
                    this.redirectToYoutube();
                }
                service.hideLoader();
            }).catch((error) => {
                console.error(error);
                service.hideLoader();
            });
        } else {
            this.redirectToYoutube();
        }
    }

    setBookMark(videoId, status) {
        if (global.ftk != '') {
            service.showLoader();
            var postData = {
                "videoId": videoId,
                "status": status.toString()
            }
            var url = global.api_ci_url + "Videos/setBookMark";
            service.postServiceCall(url, postData).then((json) => {
                console.log(json);
                if (json['msg'] == "1") {
                    this.changeData(videoId, "bookmark", status);
                }
                service.hideLoader();
            }).catch((error) => {
                console.error(error);
                service.hideLoader();
            });
            return true;
        } else {
            service.showAlert("Please Login");
            window.location.href = global.loginUrl + '?URL=' + global.currentURL;
            return false;
        }
    }

    callAPI = (url, postData) => {
        return service.postServiceCall(url, postData)
            .then((json) => {
                console.log("Full API Response::", json);
                if (json.msg == 1) {
                    const result = json.result || json.videos || {};
                    console.log("result ::", result)
                    // For videos, update videoData and keywordData from the result if available
                    if (result.videos) {
                        this.setState({
                            videoData: result.videos,
                            keywordData: result.keywordList || [],
                        });
                    }
                }
                return json; // Return the response to use in Promise.all
            })
            .catch((error) => {
                console.error("API Call Error----:", error);
                throw error; // Ensure the error propagates to Promise.all's catch
            });
    }


    SelectChild = (child, imageUrl) => { 

        console.log("child ======", child);

        this.setState({
            dob: child.DOB,
            childid: child.ChildId,
            childgender: child.Gender,
            childname: child.ChildName,
            isexpectedchild: child.IsExpected,
            selectedChild: {
                name: child.ChildName,
                photo: imageUrl,
                expected: child.IsExpected
            }
        }, () => {

            // const postData = this.getPostData();

            const postData = {
                "searchkey": "All",
                "pageSize": 10,
                "pageNo": 1,
                "childDob": child.DOB || "",
                "isExpecting": child.IsExpected ? 1 : 0,
            }

            console.log("SelectChild postData::", postData);

            const url1 = `${global.api_ci_url}api/fetchfromCI/getVideos`;

            console.log("SelectChild URL1:", url1);

            // Use Promise.allSettled for concurrent API calls
            service.showLoader();
            this.callAPI(url1, postData)
                .then((response) => {
                    if (response && response.videos) {
                        this.setState({
                            videoData: response.videos,
                            keywordData: response.keywordList || [],
                        });
                    }
                })
                .catch((error) => {
                    console.error("SelectChild API failed:", error);
                })
                .finally(() => {
                    service.hideLoader();
                });

            document.getElementsByClassName("dropdown_sec_wrap")[0].style.paddingBottom = "6px";
        });

        this.setState({ showDropdownBody: true });
        document.getElementsByClassName("dropdown_body")[0].style.display = "none";
        document.getElementsByClassName("sel_down_arrow")[0].style.transform = "rotate(0deg)";

      
    }

    DropdownClick = () => {
        
        const dropdownBody = document.getElementsByClassName("dropdown_body")[0];
        const rotatearr = document.getElementsByClassName("sel_down_arrow")[0];
        const dropsec = document.getElementsByClassName("dropdown_sec_wrap")[0];
        if (dropdownBody.style.display === "block") {
            dropsec.style.paddingBottom = "6px";
            dropdownBody.style.display = "none";
            rotatearr.style.transform = "rotate(0deg)";
            this.setState({ showDropdownBody: true });

        } else {
            if (window.innerWidth > 767) {
                dropsec.style.paddingBottom = "12px";
            }
            dropdownBody.style.display = "block";
            rotatearr.style.transform = "rotate(180deg)";
            this.setState({ showDropdownBody: false });

        }
    }

    getAgeCategory = (age) => {
        const ageParts = age.split(' ');

        let years = 0;
        let months = 0;
        let days = 0;

        for (let i = 0; i < ageParts.length; i++) {
            if (ageParts[i].includes('year')) {
                years = parseInt(ageParts[i - 1], 10);
            } else if (ageParts[i].includes('month')) {
                months = parseInt(ageParts[i - 1], 10);
            } else if (ageParts[i].includes('day')) {
                days = parseInt(ageParts[i - 1], 10);
            }
        }

        if (years === 0 && months === 0 && days <= 182) { // 0 to 6 months (approximately 182 days)
            return "0";
        } else if (years === 0 && months <= 6) { // 0 to 6 months
            return "0";
        } else if ((years === 0 && months > 6) || (years === 1 && months <= 11)) { // 6 months to 2 years
            return "7";
        } else if (years >= 2 && years < 4) { // 2 to 4 years
            return "1";
        } else if (years >= 4 && years < 6) { // 4 to 6 years
            return "2";
        } else if (years >= 6) { // 6+ years
            return "8";
        } else {
            return null;
        }
    };

    render() {

        const ageCategoryToImage = {
            "0": 'https://cdn.cdnparenting.com/brainbees/community/preact/public/media/01-Infant.webp',
            "7": 'https://cdn.cdnparenting.com/brainbees/community/preact/public/media/02-Baby.webp',
            "1": 'https://cdn.cdnparenting.com/brainbees/community/preact/public/media/03-Toddler.webp',
            "2": 'https://cdn.cdnparenting.com/brainbees/community/preact/public/media/04-Kids.webp',
            "8": 'https://cdn.cdnparenting.com/brainbees/community/preact/public/media/05-Big Kids.webp',
            "5": 'https://cdn.cdnparenting.com/brainbees/community/preact/public/media/06-Expecting.webp',
            "4": 'https://cdn.cdnparenting.com/brainbees/community/preact/public/media/07-Trying-to-concieve.webp'
        };

        const { childlist, selectedChild, showDropdownBody, browswerCategory } = this.state;
        
        return (
            <main className="main-container">
                <Helmet
                    title={this.state.metaTitle}
                    meta={this.state.metaDescription}
                />
                <div className="title">
                    <div className="breadcrumb R11_9e">
                        <span><a href={service.getRedirectUrl("/")} className="R11_9e">Home</a></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span>Videos</span>
                    </div>
                    <h1 className="B24_00" id="skipToH1" tabIndex={0}>Videos</h1>
                </div>
                <div className="sub-container left">
                    <div className="data-container left">
                        <div className="videos_container">

                            {
                                
                                global.ftk != "" ?
                                <div className='dropdown_sec_wrap'>
                                    <div className='dropdown_head' onClick={this.DropdownClick}>
                                        {showDropdownBody ?
                                            <div className='select_child M20_21'>
                                                <div className='dropdown_row'>
                                                    {!childlist.length == 0 ?
                                                        <div className='arti_circle_img sel_profile'>
                                                            <img src={selectedChild.photo} />
                                                        </div> : ""}
                                                    <div className='select_child M20_21'>
                                                        {!childlist.length == 0 ? (
                                                            <>View Videos for <span style={{ color: "#fd5387", fontFamily: "Roboto-Medium", textTransform: "capitalize" }}>{selectedChild.expected ? "Expecting" : selectedChild.name}</span></>
                                                        ) : (
                                                            <>Select Child</>
                                                        )}
                                                    </div>
                                                    {/* <div className='select_child M20_21'>Read Articles for <span style={{ color:"#fd5387"}}>{selectedChild.name}</span> </div> */}
                                                </div>
                                            </div> : <div className='select_child M20_21 sel_txt'>Select Child</div>}
                                        <div className='sel_down_arrow' data-icon-font="f"></div>
                                    </div>
                                    <div className='dropdown_body'>
                                        {childlist.map(child => {
                                            let ageCategory;
                                            let defaultImageUrl;
                                            if (child.Age) {
                                                ageCategory = this.getAgeCategory(child.Age);
                                                defaultImageUrl = ageCategory ? ageCategoryToImage[ageCategory] : null;
                                            }
                                            else {
                                                defaultImageUrl = "https://cdn.cdnparenting.com/brainbees/community/preact/public/media/06-Expecting.jpg"
                                            }

                                            // console.log("profile:::::::::::::::::", child.Age, ageCategory, defaultImageUrl)
                                            // console.log("ageCategory:", ageCategory)
                                            // console.log("defaultImageUrl:", defaultImageUrl)

                                            const imageUrl = child.childPhoto || defaultImageUrl;

                                            return (
                                                <div key={child.ChildId} className='dropdown_row' >
                                                    <div className={`arti_circle_img ${selectedChild.name === child.ChildName ? "sel_child_img" : ""}`}>
                                                        <img className='gtm-select-child' src={imageUrl} />
                                                    </div>

                                                    <div className='article_name R17_42 gtm-select-child' onClick={() => this.SelectChild(child, imageUrl)} style={{ color: selectedChild.name === child.ChildName ? "#fd5387" : "", fontFamily: selectedChild.name === child.ChildName ? "Roboto-Medium" : "" }}>
                                                        {child.IsExpected ? "Expecting" : child.ChildName}
                                                    </div>
                                                </div>
                                            );
                                        })}


                                        <div className='dropdown_row' onClick={(e) => this.AddChild(e)}>
                                            <div className='arti_circle_img arti_circle' >
                                                <span className='plus_icon gtm-add-child' data-icon-font="8"></span>
                                            </div>
                                            <a 
                                            href={service.getRedirectUrl('/my-account/myprofile')} target="_self"
                                            className='article_name R17_42 gtm-add-child' style={{ color: "#424242" }}>Add Your Child</a>
                                        </div>
                                    </div>
                                </div> : ""

                            }

                            <div className="tab_container left">
                                <div className="video_tabs left" id="keySlider">
                                    <ul className="left">
                                        {this.state.keywordData && this.state.keywordData.map((key, index) =>
                                            <li key={index} className={key.replace(/&amp;/g, "&") == this.state.activeKey ? "left active" : "left"} onClick={() => this.changeKey(key.replace(/&amp;/g, "&"))}>
                                                <span className={key.replace(/&amp;/g, "&") == this.state.activeKey ? "M14_white" : "M14_42"}>{key}</span>
                                            </li>
                                        )}
                                    </ul>
                                    <div className="arrows">
                                        <span className="next" onClick={() => service.slideSlider('keySlider', 250, 300)}>
                                            <span data-icon-font="h" className="icon"></span>
                                        </span>
                                        <span className="prev" onClick={() => service.slideSlider('keySlider', -250, 300)}>
                                            <span data-icon-font="g" className="icon"></span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div className="youtube_subscribe left" onClick={() => this.saveVideoSubscription()}>
                                {this.state.windowWidth < 768 ?
                                    <img className="left" src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/image_mobile.png" />
                                    :
                                    <img className="left" src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/image_desk.png" />
                                }
                                <span className={this.state.windowWidth < 768 ? "R14_61 left subscribe_channel" : "R20_61 left subscribe_channel"}>
                                    For Regular updates, please subscribe to our YouTube channel.
                                </span>
                                {this.state.windowWidth < 768 ?
                                    <img className="right subscribeBTN" src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/subscribe-button-m.png" />
                                    :
                                    <img className="right subscribeBTN" src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/button_desk.png" />
                                }
                            </div>
                            <div className="all_videos">
                                {this.state.videoData && this.state.videoData.map((video, index) =>
                                    <div key={index} className="videos_list">
                                        <div className="video_block" data-id={video.id}>
                                            {video.url &&
                                                <YouTube videoId={video.url.split('=')[1]} height={this.state.videoHeight} width={this.state.videoWidth} onStateChange={this.onPlayerStateChange} />
                                            }
                                            <div className="video_details">
                                                {/* <span className="M14_white">#{video.keyword}</span> */}
                                                <span className="M19_white">{video.title.replace('â€™', "&#39;")}</span>
                                            </div>
                                        </div>
                                        <div className="view_details left">
                                            <span className="left social_activities">
                                                <span className="icon left" data-icon-font="$"></span>
                                                <span className="R14_9e">{service.intToString(video.view_count)} Views</span>
                                            </span>
                                            <span className="left social_activities likeactivity">
                                                <span className={video.isLike ? "icon left likeicon isliked" : "icon left likeicon"} data-icon-font="&#xe020;" onClick={() => this.saveVideoAction(video.id, "like", video.isLike ? 0 : 1)}></span>
                                                <span className="R14_9e">{service.intToString(video.like_count)} Likes</span>
                                            </span>
                                            <span className="left social_activities bookmarkactivity">
                                                {video.isBookmarked ?
                                                    <span className="icon left bookmarkicon isliked" data-icon-font="&#xe04e;" onClick={() => { this.setBookMark(video.id, 0); }}></span>
                                                    :
                                                    <span className="icon left bookmarkicon unbookimg" onClick={() => { this.setBookMark(video.id, 1); }}>
                                                        <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/unbookmark.png" alt="Unbookmark Icon" title="Unbookmark Icon" />
                                                    </span>
                                                }
                                                <span className="R14_9e">{service.intToString(video.bookmarkCount)} Bookmarks</span>
                                            </span>
                                            <div className="card-share social-actions" id={`share_${video.id}`}>
                                                <span className="R14_9e left share-icon share-click" onClick={() => this.shareOn(video.id)}>
                                                    <div data-icon-font="" className="icon left share-click"></div>
                                                    <div data-icon-font="" className="icon left share-click"></div>
                                                    <div className="R14_9e left share-click share-vtext">Share</div>
                                                </span>
                                                <ShareOptions video={video} eleRef={this} />
                                            </div>
                                        </div>
                                    </div>
                                )}
                                <input type="hidden" id="pageNo" value="" />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="share-overlay"></div>
                <Right url={this.props.location.pathname} />
            </main>
        )
    }
}

export default withLocation (Videos);
